import EsusView from 'components/esus/EsusView'

export default function AtividadeColetivaView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoAtividadeColetiva' />
}
